export const decialRegex = /^-?\d*\.?\d*$/;
export const numberRegex = /^-?\d*$/;
